import { MockSalaryDetails } from 'wingman-fe';

import { ThemedExample } from '#src/components/ThemedExample/ThemedExample.tsx';

export const SeekSalaryDetails = () => (
  <ThemedExample>
    <MockSalaryDetails
      onBlur={() => undefined}
      schemeId="seekAnzPublicTest"
      showStorybookAction
    />
  </ThemedExample>
);
